import { AnimatePresence, motion } from "motion/react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/hooks/use-theme";
import { haptic } from "@/lib/telegram";
import { cn } from "@/lib/utils";

export function ThemeToggle({ className }: { className?: string }) {
  const { theme, toggle } = useTheme();

  return (
    <motion.button
      type="button"
      aria-label={theme === "dark" ? "Switch to light theme" : "Switch to dark theme"}
      whileTap={{ scale: 0.9 }}
      transition={{ type: "spring", stiffness: 520, damping: 20 }}
      onClick={() => {
        haptic("light");
        toggle();
      }}
      className={cn(
        "glass relative grid size-10 shrink-0 place-items-center overflow-hidden rounded-full",
        className,
      )}
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={theme}
          initial={{ opacity: 0, rotate: -70, scale: 0.6 }}
          animate={{ opacity: 1, rotate: 0, scale: 1 }}
          exit={{ opacity: 0, rotate: 70, scale: 0.6 }}
          transition={{ type: "spring", stiffness: 320, damping: 22 }}
          className="grid place-items-center"
        >
          {theme === "dark" ? (
            <Moon className="size-[18px] text-primary" />
          ) : (
            <Sun className="size-[18px] text-warning" />
          )}
        </motion.span>
      </AnimatePresence>
    </motion.button>
  );
}